import BatteryRecycle from './BatteryRecycle';

export default BatteryRecycle;
